module.exports = __webpack_public_path__ + "static/media/star-number.e31abd37.png";